// @core/api/endpoints/platform/register_in_registry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformRegistryEntryResponse,
  RegisterInRegistryRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Register platform in registry
 * Registers this platform in the central discovery registry. Other platforms can then find and initiate federation.
 */
export async function RegisterInRegistry(
  data: RegisterInRegistryRequest,
  options?: RequestOptions
): Promise<PlatformRegistryEntryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/registry/platforms`;
  const requestOptions = options;
  return client.post<PlatformRegistryEntryResponse>(requestPath, data, requestOptions);
}
